import React from 'react';
import { extensions, bowser } from '@yola/ws-sdk';
import { AI_WRITE_TEXT_TRIGGER_ID } from 'src/js/modules/control-pane/constants/trigger-ids';
import serviceClient from 'yola-editor/src/js/modules/feature-flags/service-client';
import getParentBlockByElement from 'src/js/modules/blocks/helpers/get-parent-block-by-element';
import customUI from 'src/js/modules/custom-ui';
import constants from '../constants';
import typedElementsMatches from '../helpers/typed-elements-matches';
import AiWriterTrigger from '../components/ai-writer-trigger';

const { controlTypes } = extensions;
const {
  SLUG,
  AI_WRITER_TRIGGER_WIDTH,
  AI_WRITE_TEXT_ACTIVE_HEADER_MOBILE_WIDTH,
  AI_WRITE_TEXT_ACTIVE_HEADER_WIDTH,
} = constants.common;

const triggerId = AI_WRITE_TEXT_TRIGGER_ID;

function elementMatches(element) {
  const featureFlagsManager = serviceClient.get();
  const { ai_text_assistant_write: isFeatureFlagEnabled } = featureFlagsManager.state;

  if (!isFeatureFlagEnabled) {
    return false;
  }

  const parentBlock = getParentBlockByElement(element);
  const { textContainer, aiTextAssistantRestrictedBlocksSelector } =
    extensions.accessors.getExtensionSettings(SLUG);

  if (
    !element.matches(textContainer) ||
    parentBlock.matches(aiTextAssistantRestrictedBlocksSelector)
  ) {
    return false;
  }

  const typedElements = typedElementsMatches();
  return Boolean(typedElements.length);
}

const control = {
  id: triggerId,
  trigger: <AiWriterTrigger width={AI_WRITER_TRIGGER_WIDTH} />,
  width: AI_WRITER_TRIGGER_WIDTH,
  priority: 62,
  for: [controlTypes.COLLAPSED_TEXT],
  highlightElement: false,
  matches: elementMatches,
  onTriggerClick: (elementId, { getContext }) => {
    const {
      controlPane: { position },
    } = getContext();
    const { x } = position;
    const aiWriterWidth = bowser.mobile
      ? AI_WRITE_TEXT_ACTIVE_HEADER_MOBILE_WIDTH
      : AI_WRITE_TEXT_ACTIVE_HEADER_WIDTH;
    const aiWriterPosition = {
      left: x - aiWriterWidth / 2,
      width: aiWriterWidth,
    };

    customUI.operations.show(customUI.customUiTypes.AI_WRITE, {
      elementId,
      triggerId,
      getContext,
      position: aiWriterPosition,
      hideAiWriter: () => customUI.operations.hide(),
    });
  },
};

export default control;
